import { ContentBlockCopySectionCentered } from '@dfh-corp-sites/ui'
import { ChevronRight } from 'lucide-react'
import React from 'react'

import { SanityContentBlockCopySectionCentered as ContentBlockCopyCenteredProps } from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'
import { useSanityRoleBasedContent } from '../../../lib/sanity'
import SanityLink, { NormalizedSanityLinkTagged } from '../../global/SanityLink'
import BodyPortableText from '../BodyPortableText'

const setAnalyticsEventOnClick = (
  cta: ContentBlockCopyCenteredProps['cta'],
  link: NormalizedSanityLinkTagged,
  title: ContentBlockCopyCenteredProps['title'],
) => {
  setAnalyticsEvent({
    event: 'select_content',
    content_type: 'content block',
    item_id: `sanitycontentblock-copysectionccentered`,
    title: title || '',
    label_text: cta?.title || '',
    link_destination: link._tag === 'Normalized' ? link.href ?? undefined : link._tag,
    module_name: 'SanityContentBlock',
    module_variant: 'SanityContentCopySectionCentered',
  })
}

const SanityContentBlockCopySectionCentered = ({
  title,
  content,
  cta,
  ctaAriaLabel,
  roleBasedContent,
}: ContentBlockCopyCenteredProps) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  if (!shouldDisplay) return null

  const ctaChildren =
    cta?.link && cta.link.target && cta.link.target.length > 0 ? (
      <SanityLink
        to={cta.link}
        onClick={(_e, normalized) => setAnalyticsEventOnClick(cta, normalized, title)}
      >
        {cta.title} <ChevronRight />
      </SanityLink>
    ) : null

  const contentBlock = content ? <BodyPortableText blocks={content} /> : null

  return (
    <ContentBlockCopySectionCentered
      title={title || ''}
      content={contentBlock}
      ctaChildren={ctaChildren}
      ctaAriaLabel={ctaAriaLabel || ''}
    />
  )
}

export default SanityContentBlockCopySectionCentered
